import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import ContentSection from "@/pages/home/components/ContentSection";
import HotRanking from "@/pages/home/components/HotRanking";
import SpecialShowcase from "@/pages/home/components/SpecialShowcase";
import { getHotMedia, getNewMedia } from "@/utils/media";

export default function Home() {
  useDocumentMeta({
    title: "亚洲一区二区在线-免费高清亚洲影视在线观看平台",
    description:
      "亚洲一区二区在线提供丰富的亚洲影视资源，涵盖最新电影、电视剧和综艺节目，满足用户在线观看各种亚洲影视内容的需求。",
    keywords:
      "亚洲一区二区在线,亚洲影视,在线观看亚洲电影,亚洲电视剧,日韩电影在线观看,亚洲综艺节目,亚洲影视资源",
  });

  const newMedia = getNewMedia(6);
  const hotMedia = getHotMedia(6);

  return (
    <div className="pb-4">
      <h1 className="sr-only">
        亚洲一区二区在线 - 免费高清亚洲影视在线观看平台
      </h1>

      <HeroCarousel />

      <div className="mt-8 space-y-10">
        <CategoryQuickLinks />

        <div className="mx-auto w-full px-4 md:px-6">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div className="space-y-10 lg:col-span-2">
              <ContentSection
                title="最新上线"
                subtitle="刚刚上架的新片新剧，抢先一步看新鲜"
                icon="ri-time-line"
                moreTo="/category/movie"
                items={newMedia}
              />
              <ContentSection
                title="热门点击"
                subtitle="近期人气飙升的作品，大家都在看"
                icon="ri-fire-line"
                moreTo="/category/drama"
                items={hotMedia}
              />
            </div>

            <aside className="space-y-6 lg:col-span-1">
              <HotRanking />
              <div className="rounded-lg border border-background-200 bg-secondary-50 p-4 md:p-5">
                <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                  <i className="ri-information-line text-secondary-500"></i>
                  关于本站
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  亚洲一区二区在线专注整合亚洲影视内容，提供多维筛选、评分参考与专题推荐，帮你更快找到想看的作品。
                </p>
                <p className="mt-3 rounded-md bg-background-50 px-3 py-2 text-xs leading-relaxed text-foreground-600">
                  <i className="ri-alert-line mr-1 text-accent-500"></i>
                  本站为演示站点，所有影视名称、评分与人物信息均为虚构，不提供真实播放服务。
                </p>
              </div>
            </aside>
          </div>
        </div>

        <SpecialShowcase />
      </div>
    </div>
  );
}